import { jsx } from "react/jsx-runtime";
import Skeleton from "react-loading-skeleton";
import CellContainer from "./CellContainer.js";
import { named } from "../../utils/named.js";
const LoadingRenderer = (props) => {
  return /* @__PURE__ */ jsx(CellContainer, { ...props, children: /* @__PURE__ */ jsx(
    "div",
    {
      style: {
        width: "100%",
        height: "100%",
        flex: 1
      },
      children: /* @__PURE__ */ jsx(
        Skeleton,
        {
          style: {
            width: "100%",
            height: "100%",
            transform: "translateY(-3px)"
          },
          width: "100%",
          height: "100%"
        }
      )
    }
  ) });
};
named("LoadingRenderer", LoadingRenderer);
export {
  LoadingRenderer as default
};
